import { Item } from '../types/item.types';
import { SubItem } from '../types/sub-item.types';
import create from 'zustand';

type ActionState = {
   partsToCopy: SubItem[];
   itemNos: Array<Item['itemNo']>;
   familyName?: string;
};

export const copyState = create<ActionState>(() => ({
   partsToCopy: [],
   itemNos: [],
}));

export const useCopyParts = () => {
   const [copiedParts, pasteToItems, familyName] = copyState((s) => [s.partsToCopy, s.itemNos, s.familyName]);
   const hasCopiedParts = copiedParts.length > 0;
   const copyParts = (parts: SubItem[]) => {
      copyState.setState({
         itemNos: [],
         partsToCopy: parts,
      });
   };

   const copyPartsData = copiedParts.map((p) => ({
      matSetName: p.matSetName,
      id: p.id,
      parentId: p.parentId,
   }));

   const selectItemsToPasteTo = (items: Item[]) => {
      const pasteToItemNos = items.map((i) => i.itemNo);

      copyState.setState((s) => ({
         ...s,
         itemNos: pasteToItemNos,
      }));
   };

   const setFamilyName = (familyName?: string) => {
      copyState.setState((s) => ({
         ...s,
         familyName,
      }));
   };

   return {
      copiedParts,
      copyPartsData,
      hasCopiedParts,
      pasteToItems,
      familyName,
      copyParts,
      selectItemsToPasteTo,
      setFamilyName,
   };
};
